<template>
  <div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="12">
          <b-tabs defaultActiveKey="1" class="air-tabs-bordered mb-2" justified>
            <!-- <a-tab-pane v-for="aTag in tags" :tab="aTag.title" :key="aTag.key"> -->
            <b-tab title="三Journeys" active="">
              <b-table
                :items="serveJourneyList"
                :fields="tableJourneyConfig.fields"
                responsive="sm"
              >
              </b-table>
              <b-button
                @click="isModalAddNewName = true"
                variant="outline-secondary"
                class="fa fa-plus button-add"
              >
              </b-button>
            </b-tab>
            <b-tab title="三Events">
              <b-table
                :items="serveEventList"
                :fields="tableEventConfig.fields"
                responsive="sm"
              >
              </b-table>
            </b-tab>
            <b-tab title="三Engines">
              <b-table
                :items="serveEngineList"
                :fields="tableEngineConfig.fields"
                responsive="sm"
              >
              </b-table>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
// import SwitchFilter from "@/components/_savco/switch";
// import SavcoUserMenu from "@/components/_savco/layout/TopBar/UserMenu";
import moment from "moment";
export default {
  components: {
    // SwitchFilter,
    // SavcoUserMenu
  },
  beforeCreate() {},
  methods: {
    handleFilterFocus(e) {
      console.log(e, "where to handle filter focus");
    },
    handleAddFocusBtnClick: function() {
      console.log("triggered add button");
    }
  },
  computed: {
    serveJourneyList() {
      let tableData = this.$store.getters["user/listJourneys"].filter(
        el => !el._deleted_at
      );
      return tableData.map(el => {
        return { journey: el.text, ...el };
      });
    },
    serveEventList() {
      let tableData = this.$store.getters["user/listEvents"];
      return tableData.map(el => {
        return {
          event: el.engine,
          when: el._start_at,
          at: `${moment(new Date(el._start_at.toDate())).format(
            "hh:mm A"
          )} to ${moment(new Date(el._end_at.toDate())).format("hh:mm A")}`,
          "<P>lace": el.place
        };
      });
    },
    serveEngineList() {
      // debugger;
      let tableData = this.$store.getters["user/listEngine"];
      let beforeFilterDeletedAt = tableData.map(el => {
        return {
          text: el.text,
          when: el.when,
          uid: el.uid,
          created_at: el._created_At
        };
      });
      return beforeFilterDeletedAt.filter(el => !el._deleted_at);
    }
  },
  data() {
    return {
      tags: [
        {
          title: "<> Names",
          key: 0
        },
        {
          title: "<> Numbers",
          key: 1
        },
        {
          title: "<> Places",
          key: 2
        },
        {
          title: "<> Tools",
          key: 3
        }
      ],
      // FIELD FOR ADD NAMES
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      notes: "",
      //////////////////////
      tableJourneyConfig: {
        fields: [
          { key: "uid", sortable: true, label: "ID", thStyle: "width: 10%" },
          { key: "journey", sortable: true, thStyle: "width: 75%" },
          { key: "shef", sortable: false, label: "", thStyle: "width: 15%" },
          { key: "Actions", label: "", sortable: false, thStyle: "width: 10%" }
        ]
      },
      tableEventConfig: {
        fields: [
          { key: "uid", sortable: true, label: "ID", thStyle: "width: 10%" },
          { key: "event", sortable: true },
          {
            key: "when",
            sortable: true,
            formatter: value => {
              return moment(new Date(value.toDate())).format(
                "dddd, DD MMMM YYYY"
              );
            }
          },
          { key: "at", sortable: true },
          { key: "<P>lace", sortable: true }
        ]
      },
      tableEngineConfig: {
        fields: [
          { key: "uid", sortable: true, label: "ID", thStyle: "width: 10%" },
          {
            key: "text",
            sortable: true,
            label: "Engine",
            thStyle: "width: 50%"
          },
          { key: "when", sortable: true, label: "When", thStyle: "width: 10%" },
          { key: "created", label: "", sortable: false, thStyle: "width: 30%" }
        ]
      },
      spheres: [
        { sphere: "s" },
        { sphere: "h" },
        { sphere: "e" },
        { sphere: "f" }
      ],
      isModalAddNewName: false
    };
  },
  mounted() {
    this.$store.dispatch("user/getListJourneys");
    this.$store.dispatch("user/getListEngines");
    this.$store.dispatch("user/getListEvents");
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.button-add {
  width: 100%;
  background-color: #575757;
  color: white;
}
</style>
